import { mount } from './ui.js';
import type { SupportAgentCtx } from './types.js';

declare global {
  interface Window {
    SUPPORT_AGENT_CTX?: SupportAgentCtx;
    SUPPORT_AGENT_WIDGET?: { mounted: boolean };
  }
}

(function boot() {
  if (typeof window === 'undefined') return;
  if (window.SUPPORT_AGENT_WIDGET?.mounted) return; // idempotent

  const ctx = window.SUPPORT_AGENT_CTX;
  if (!ctx || !ctx.shop) {
    // Merchant misconfigured — log helpfully and bail without throwing.
    // eslint-disable-next-line no-console
    console.warn(
      '[support-agent-widget] window.SUPPORT_AGENT_CTX is missing — paste the Liquid snippet before <script src=".../widget.js">.',
    );
    return;
  }

  const start = () => {
    mount(ctx);
    window.SUPPORT_AGENT_WIDGET = { mounted: true };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
